import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IGenerateGrammarAudioV1Request } from './generate-grammar-audio-v1-request';
import type { IGenerateGrammarAudioV1Response } from './generate-grammar-audio-v1-response';
import { generateGrammarAudioV1ResponseSchema } from './generate-grammar-audio-v1-response';

export async function generateGrammarAudioV1Api(
  body: IGenerateGrammarAudioV1Request = {},
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGenerateGrammarAudioV1Response>> {
  return postRequest<IGenerateGrammarAudioV1Response>({
    path: '/sys/grammar/v1/audio/generate',
    body,
    schema: generateGrammarAudioV1ResponseSchema,
    options,
  });
}
